import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import "./transaction-progress.css";
import { useNavigate } from "react-router-dom";
export default function TransactionProgress() {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const goBack = () => navigate(-1);
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => (prev >= 100 ? 0 : prev + 10));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="modal-overlay">
      <div className="progress-modal">
        {/* Close Button */}
        <button onClick={goBack} className="modal-close">
          <X size={20} />
        </button>

        {/* Hourglass Animation */}
        <div className="hourglass-container">
          <div className="hourglass">⏳</div>
        </div>

        {/* Title */}
        <h2 className="modal-title">Transaction in progress</h2>

        {/* Description */}
        <p className="modal-description">
          You can view the details and track the progress in the transaction
          records.
        </p>

        {/* Progress Info */}
        <div className="records-list" onClick={() => navigate("/transactions")}>
          <TransactionCard
            date="Today 2026-01-14"
            status="Processing"
            statusType="processing"
            type="Deposit"
            transactionId="D0090425318"
            method="Bkash (E-wallet)"
            time="2026-01-14 11:55:57"
            amount="৳ 500.00"
            isPositive={true}
          />
        </div>

        {/* Close Button */}
        <button onClick={goBack} className="close-button-dep">Close</button>
      </div>
    </div>
  );
}
function TransactionCard({
  date,
  status,
  statusType,
  type,
  transactionId,
  method,
  time,
  amount,
  isPositive,
}) {
  return (
    <div className="transaction-group">
      {/* Date Header */}
      <div className="card-date">{date}</div>

      {/* Card Content */}
      <div className="card-content">
        {/* Status Badge */}
        <div className={`status-badge ${statusType}`}>
          <svg
            className="status-icon"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="2" />
            <circle cx="7" cy="7" r="2" fill="currentColor" />
          </svg>
          <span className="status-text">{status}</span>
        </div>

        {/* Transaction Type */}
        <div className="transaction-type">{type}</div>

        {/* Details Row */}
        <div className="details-row">
          <div className="transaction-info">
            <div className="transaction-id">{transactionId}</div>
            <div className="transaction-method">{method}</div>
          </div>
          <button
            
            className="details-btn"
          >
            Details
          </button>
        </div>

        {/* Bottom Row */}
        <div className="bottom-row">
          <div className="transaction-time">{time}</div>
          <div className={`amount ${isPositive ? "positive" : "negative"}`}>
            {amount}
          </div>
        </div>
      </div>
    </div>
  );
}
